var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramFestaTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 28,
    viewBox: "0 0 177 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_44926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28L0 14L14 0L28 14L14 28ZM4.94755 14L14 23.0525L23.0525 14L14 4.94755L4.94755 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19.8925L8.10748 13.9999L14 8.10742L19.8925 13.9999L14 19.8925ZM13.055 13.9999L14 14.9449L14.945 13.9999L14 13.055L13.055 13.9999Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_518_44926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5584 1.6084H55.3882V26.3848H59.5584V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9239 1.6084H66.7537V26.3848H70.9239V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5798 11.2157L56.8021 15.2344L58.1487 19.1812L69.9265 15.1625L68.5798 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6487 1.6416H36V5.81181H50.6487V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4128 3.72656H41.2426V26.3582H45.4128V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.818 28L73.8099 13.1461L82.9844 0L86.4 2.38298L78.94 13.0733L88.1674 25.5177L84.818 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4927 11.0283H76.3783V15.1985H86.4927V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_518_44926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.675 26.3409L166.37 8.7073L160.423 26.3077L156.475 24.9737L164.346 1.69236L166.084 1.67909L168.281 1.65918L176.597 24.9405L172.675 26.3409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.435 19.1271L166.544 16.2363L163.653 19.1271L166.544 22.0179L169.435 19.1271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.335 27.064H96.1674V5.11663L106.328 0.935547L107.914 4.7848L100.335 7.90402V27.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.26 12.0315L97.391 16.0488L99.1108 19.8453L107.979 15.828L106.26 12.0315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.101 27.3168L127.532 24.0316L133.425 19.4324L126.019 10.4L135.642 0.564453L138.622 3.47794L131.614 10.6455L139.359 20.0895L130.101 27.3168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.488 1.5791H141.834V5.74691H156.488V1.5791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.245 3.66309H147.077V26.3007H151.245V3.66309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.763 28L109.753 13.1472L118.924 0L122.342 2.38256L114.883 13.0742L124.108 25.5179L120.763 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.435 11.0303H112.321V15.1981H122.435V11.0303Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_44926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_518_44926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1674,
    height: 28,
    fill: "white",
    transform: "translate(36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_518_44926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.4295,
    height: 28,
    fill: "white",
    transform: "translate(96.1674)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramFestaTab);
export default __webpack_public_path__ + "static/media/programFestaTab.cc377c9582efdbeee9512446ec6f6e4c.svg";
export { ForwardRef as ReactComponent };